import wretch from 'wretch';
import * as v from 'valibot';
import { ResourcesSchema, TResourceData } from '@fe-learner-common';
import { localizedErrorHandlers } from '@fe-core/api';

const delayPromise = new Promise((resolve) => setTimeout(resolve, 800));

export const getResourcesData = async (
  baseUrl: string,
  participationId: string,
): Promise<TResourceData[]> => {
  const url = `${baseUrl}/participation/${participationId}/resources`;
  const instance = wretch(url, {
    credentials: 'include',
  }).get();

  const dataPromise = localizedErrorHandlers(instance).json((response) => {
    const validatedResponse = v.safeParse(ResourcesSchema, response);

    if (validatedResponse?.success) {
      return validatedResponse.output.resources;
    } else {
      console.error(
        'fe-learner-common | getResourceData | ',
        validatedResponse.issues,
      );
      throw new Error('Invalid resources response');
    }
  });

  const [result, _] = await Promise.all([dataPromise, delayPromise]);
  return result;
};

export const markAsRead = async ({
  baseUrl,
  resourceId,
  participationId,
}: {
  baseUrl: string;
  participationId: string;
  resourceId: string;
}) => {
  const url = `${baseUrl}/participation/${participationId}/resource/${resourceId}/mark`;

  const instance = wretch(url, {
    credentials: 'include',
  }).post();

  return localizedErrorHandlers(instance).json((response) => {
    const validatedResponse = v.safeParse(ResourcesSchema, response);

    if (validatedResponse?.success) {
      return validatedResponse.output.resources;
    } else {
      console.error(
        'fe-learner-common | resources markAsRead | ',
        validatedResponse.issues,
      );
      throw new Error('Invalid resources response');
    }
  });
};
